import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TopToolbar } from "react-admin";
import { CreateButton, ExportButton } from "ra-ui-materialui";
import { ImportData } from "./ImportData";
export const ListActions = (listActionProps) => {
    const { className, total, sort, filterValues, exporter, hasCreate = true, customCreateLabel } = listActionProps;
    return (_jsxs(TopToolbar, { className: className, children: [hasCreate && _jsx(CreateButton, { label: customCreateLabel }), _jsx(ExportButton, { disabled: total === 0, sort: sort, filterValues: filterValues, exporter: typeof exporter === "boolean" ? undefined : exporter }), _jsx(ImportData, { ...listActionProps })] }));
};
